import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { preventMaxInput, validationRules } from "../../Utils/constants";
import { isEmpty } from "lodash";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import InternalLoader from "../../component/InternalLoader";
const ChangePassword = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState([]);
  const [loader, setLoader] = useState(false);
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
  });
  const handle = (e) => {
    if (showPassword.includes(e)) {
      setShowPassword((prev) => {
        return prev?.filter((res) => {
          return res != e;
        });
      });
    } else {
      setShowPassword([...showPassword, e]);
    }
  };
  const onSubmit = async (body) => {
    setLoader(true);
    const obj = {
      oldPassword: body?.oldpassword,
      newPassword: body?.confirmPassword,
    };
    const { status, data } = await apiPost(apiPath.changePassword, obj);
    if (status === 200) {
      if (data.success) {
        logoutUser();
        navigate("/");
        toast.success(data?.message);
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
    setLoader(false);
  };
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("newPassword")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("newPassword")]);
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div>
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-loginChange mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span style={{ paddingLeft: "0" }} className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Change login password</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="flex-container security-center-container"
        >
          <div className="am-whitespace am-whitespace-lg white-space" />
          <div className="account-form no-mgbtm">
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-lock_b49219f4 am-icon-md txt-svg">
                  <use xlinkHref="#lock_b49219f4" />
                </svg>
                <input
                  type={showPassword.includes("old") ? "text" : "password"}
                  className="input-base"
                  placeholder="Enter your current password."
                  maxLength={12}
                  minLength={6}
                  {...register("oldpassword", {
                    required: "Please enter old password",
                    validate: (value) => {
                      if (value === "") {
                        return true;
                      }
                      if (!!value.trim()) {
                        return true;
                      } else {
                        return "White space are not allowed";
                      }
                    },
                    minLength: {
                      value: 8,
                      message: "Password should contain atleast 8 characters",
                    },
                    maxLength: {
                      value: 12,
                      message: "Password should contain maximum 12 characters",
                    },
                  })}
                />
              </div>
              <div onClick={() => handle("old")} className="eye-group">
                <svg
                  className={`am-icon${
                    showPassword.includes("old")
                      ? "am-icon-eyes_27cd1e8b"
                      : "am-icon-eyes-hide_2e21a0e3"
                  } am-icon-md am-icon-eyes`}
                  style={{ color: "rgb(165, 165, 165)" }}
                >
                  <use
                    xlinkHref={
                      showPassword.includes("old")
                        ? "#eyes_27cd1e8b"
                        : "#eyes-hide_2e21a0e3"
                    }
                  />
                </svg>
              </div>
            </div>{" "}
            {errors.oldpassword && errors.oldpassword.message && (
              <div className="am-flexbox am-flexbox-align-middle errors">
                <div className="am-flexbox-item">
                  <span>{errors.oldpassword.message}</span>
                </div>
              </div>
            )}
          </div>
          <div className="account-form no-mgbtm">
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-passwordBetter_0bd7a252 am-icon-md txt-svg">
                  <use xlinkHref="#passwordBetter_0bd7a252" />
                </svg>
                <input
                  type={showPassword.includes("new") ? "text" : "password"}
                  className="input-base"
                  placeholder="Please enter a new password"
                  style={{
                    "-webkit-transition": "0.15s linear",
                    transition: "0.15s linear",
                  }}
                  maxLength={12}
                  minLength={6}
                  {...register("newPassword", {
                    required: "Please enter new password",
                    validate: (value) => {
                      if (value === "") {
                        return true;
                      }
                      if (!!value.trim()) {
                        return true;
                      } else {
                        return "White space are not allowed";
                      }
                    },
                    // pattern: {
                    //   value: validationRules.password,
                    //   message:
                    //     "Password must contain lowercase,uppercase characters, numbers, special character and must be 6 character long.",
                    // },
                  })}
                />
              </div>
              <div onClick={() => handle("new")} className="eye-group">
                <svg
                  className={`am-icon${
                    showPassword.includes("new")
                      ? "am-icon-eyes_27cd1e8b"
                      : "am-icon-eyes-hide_2e21a0e3"
                  } am-icon-md am-icon-eyes`}
                  style={{ color: "rgb(165, 165, 165)" }}
                >
                  <use
                    xlinkHref={
                      showPassword.includes("new")
                        ? "#eyes_27cd1e8b"
                        : "#eyes-hide_2e21a0e3"
                    }
                  />
                </svg>
              </div>
            </div>
            {errors.newPassword && errors.newPassword.message && (
              <div className="am-flexbox am-flexbox-align-middle errors">
                <div className="am-flexbox-item">
                  <span>{errors.newPassword.message}</span>
                </div>
              </div>
            )}
          </div>
          <div className="account-form no-mgbtm">
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-passwordAgain_4b9460bf am-icon-md txt-svg">
                  <use xlinkHref="#passwordAgain_4b9460bf" />
                </svg>
                <input
                  type={
                    showPassword.includes("confirmNew") ? "text" : "password"
                  }
                  className="input-base"
                  placeholder="Confirm new password"
                  style={{
                    "-webkit-transition": "0.15s linear",
                    transition: "0.15s linear",
                  }}
                  maxLength={12}
                  minLength={6}
                  onInput={(e) => preventMaxInput(e)}
                  {...register("confirmPassword", {
                    required: {
                      value: true,
                      message: "Please enter confirm password",
                    },
                    validate: (value) => {
                      if (value === "") {
                        return true;
                      }
                      if (!isEmpty(watch("newPassword"))) {
                        if (value == watch("newPassword")) {
                          return true;
                        } else {
                          return "password and confirm password does not match.";
                        }
                      }
                    },
                  })}
                  onChange={(e) => {
                    setValue("confirmPassword", e.target.value, {
                      shouldValidate: true,
                    });
                  }}
                />
              </div>
              <div onClick={() => handle("confirmNew")} className="eye-group">
                <svg
                  className={`am-icon${
                    showPassword.includes("confirmNew")
                      ? "am-icon-eyes_27cd1e8b"
                      : "am-icon-eyes-hide_2e21a0e3"
                  } am-icon-md am-icon-eyes`}
                  style={{ color: "rgb(165, 165, 165)" }}
                >
                  <use
                    xlinkHref={
                      showPassword.includes("confirmNew")
                        ? "#eyes_27cd1e8b"
                        : "#eyes-hide_2e21a0e3"
                    }
                  />
                </svg>
              </div>
            </div>{" "}
            {errors.confirmPassword && errors.confirmPassword.message && (
              <div className="am-flexbox am-flexbox-align-middle errors">
                <div className="am-flexbox-item">
                  <span>{errors.confirmPassword.message}</span>
                </div>
              </div>
            )}
          </div>
          <p className="txt-gray">
            * Please enter 6 - 12 characters using only letters or numbers. No
            special characters allowed.
          </p>
          <div className="am-whitespace am-whitespace-lg new-space-bet" />
          <button
            style={{ width: "-webkit-fill-available" }}
            role="button"
            type="submit"
            className=" enterButton am-button btn-success "
            aria-disabled="false"
          >
            <span style={{ fontSize: ".35rem" }}>Submit</span>
          </button>
        </Form>
      </div>{" "}
      {loader && <InternalLoader />}
    </div>
  );
};

export default ChangePassword;
